import { render, staticRenderFns } from "./ServiceOrderInspectionsComponent.vue?vue&type=template&id=5ba23e26&"
import script from "./ServiceOrderInspectionsComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderInspectionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports